<template>
<div class="consulAddDialog">
  <div class="queRenBtn" style="margin-bottom:30px;">
    <el-button @click="issueCJ">议题采集信息</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <span v-if="handleStatus == 0"> <el-button  type="primary" @click="jbinfo">交办信息</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span></span>
    <el-button class="qubtn">议题办理</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <el-button class="qubtn">议题结果</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <el-button class="qubtn">结果公示</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <el-button class="qubtn">结果评议</el-button><span class="qubtn_span"></span> 
  </div>
  <div v-if="moduleShow1"> 
    <ViewAudit ref='viewAudit' :rowid='ytid' :readonly='readonlys' :closebtn='closebtn' @fMethod='dialogReturn'></ViewAudit>
  </div>
  <div v-if="moduleShow2">
    <ViewJiaoban :show="showJiaoBan" :readonlyjb='readonlyjb' ref="ViewJiaoban" :ytid='ytid' @close="closeViewJiaoban"></ViewJiaoban>
  </div>
  <div v-if="moduleShow3">
    <ViewBanLi :show="showBanLi" :readonlybl='readonlybl' ref="ViewBanLi" :ytid='ytid' @close="closeViewBanLi"></ViewBanLi>
  </div> 
  <div v-if="moduleShow4">
    <ViewJieGuo :show="showJieGuo" :readonlyjg='readonlyjg' ref="ViewJieGuo" :ytid='ytid' @close="ViewJieGuo"></ViewJieGuo>
  </div>
  <div v-if="moduleShow5">
    <ViewGongShi :show="showGongShi" :readonlygs='readonlygs' ref="ViewGongShi" :ytid='ytid' @close="closeViewGongShi"></ViewGongShi>
  </div> 
  <div v-if="moduleShow6">
    <ViewPingYi :show="showPingYi" :readonlypy='readonlypy' ref="ViewPingYi" :ytid='ytid' @close="ViewPingYi"></ViewPingYi>
  </div> 
</div>
  
</template>

<script>
import { post } from "@/api/requrestHttp";
import ViewAudit from "@/views/platform/gridding/communityIssueTitle/auditDialog.vue";
import ViewJiaoban from "@/views/platform/gridding/communityIssueTitle/showJiaobanDialog.vue";
import ViewBanLi from "@/views/platform/gridding/communityIssueTitle/showBanLiDialog.vue";
import ViewJieGuo from "@/views/platform/gridding/communityIssueTitle/showJieGuoDialog.vue";
import ViewGongShi from "@/views/platform/gridding/communityIssueTitle/showGongShiDialog.vue";
import ViewPingYi from "@/views/platform/gridding/communityIssueTitle/showPingYiDialog.vue";
import { tabdata } from "@/mixins/tabledataMix.js";
export default {
    components: { ViewAudit,ViewJiaoban,ViewBanLi,ViewJieGuo,ViewGongShi,ViewPingYi },
    props: ["ytid"],
    mixins: [tabdata],
    data() {
        return {
            handleStatus: 0,
            readonlys:true,
            readonlyjb:false,
            readonlybl:false,
            readonlyjg:false,
            readonlygs:false,
            readonlypy:false,
            showJiaoBan: false,
            showBanLi: false,
            showJieGuo: false,
            showBanLiJiLu: false,
            showGongShi: false,
            showGongShiJiLu: false,
            showPingYi: false,
            showPingYiHuiZong: false,
            showGongShiShenHe: false,
            showPingYiShenHe: false,
            showGongShi1: false,
            showGongShiJiLu1: false,
            showPingYi1: false,
            moduleShow1:false,
            moduleShow2:false,
            moduleShow3:false,
            moduleShow4:false,
            moduleShow5:false,
            moduleShow6:false,
            showGongShi: false,
            id: this.ytid,
            dialogImageUrl: '',
            dialogVisible: false,
            value1: '',
            form: {
              photo:"",
              content: ''
            },
        }
    },
    mounted(){
      this.$nextTick(() => { 
        this.getConsultList();
        this.jbinfo();
      });
      
    },
    methods: {
      closeDialog() {
        this.$emit('closeViewJiaoban');
      },
      getConsultList() {
        console.log(this.ytid);
        this.persons = [];
        post("/admin/consult/info/findConsultById", {
          id: this.ytid,
        }).then((res) => {
          console.log(res.content);
          this.consultName = res.content.consultName;
        this.content = res.content.content;
          if(res.content.bargainingLevel == '1') {
            this.bargainingLevel = '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项';
        }else if(res.content.bargainingLevel == '2') {
            this.bargainingLevel = '涉及1个村以上"两委"成员包组范围内1村(居)民组事项';
          }else if(res.content.bargainingLevel == '3') {
            this.bargainingLevel = '涉及与本镇内1个村以上范围事项';
          }else if(res.content.bargainingLevel == '4') {
            this.bargainingLevel = '涉及本镇以外其他镇的协商事项';
          }
          this.handleStatus = res.content.handleStatus;
          console.log(this.handleStatus);
          res.content.persons.filter((item) => {
            if (item.type == "0") {
              console.log(item);
              this.persons.push(item);
            }
          });
          this.negotiationContent = res.content.negotiationContent;
          console.log(this.persons);
        });
      },
        issueCJ() { //信息采集
          console.log(this.ytid);
            this.moduleShow1 = true;
            this.moduleShow2 = false;
            this.moduleShow3 = false;
            this.moduleShow4 = false;
            this.moduleShow5 = false;
            this.moduleShow6 = false; 
        },
        jbinfo() {  //交办
            this.moduleShow1 = false;
            this.moduleShow2 = true;
            this.moduleShow3 = false;
            this.moduleShow4 = false;
            this.moduleShow5 = false;
            this.moduleShow6 = false;
            setTimeout(() => {
              this.$nextTick(() => { 
                this.$refs.ViewJiaoban.getdata();
                this.$refs.ViewJiaoban.getFindConsultPersonList();
                this.$refs.ViewJiaoban.getListConsultOrg();
              })
            }, 100) 
        },
        blinfo() {//办理
            this.moduleShow1 = false;
            this.moduleShow2 = false;
            this.moduleShow3 = true;
            this.moduleShow4 = false;
            this.moduleShow5 = false;
            this.moduleShow6 = false;
            
        },
        blresult() { //结果
            this.moduleShow1 = false;
            this.moduleShow2 = false;
            this.moduleShow3 = false;
            this.moduleShow4 = true;
            this.moduleShow5 = false;
            this.moduleShow6 = false;
        },
        blpublicity() { //公示
            this.moduleShow1 = false;
            this.moduleShow2 = false;
            this.moduleShow3 = false;
            this.moduleShow4 = false;
            this.moduleShow5 = true;
            this.moduleShow6 = false;
        },
        blComment() { //评议
            this.moduleShow1 = false;
            this.moduleShow2 = false;
            this.moduleShow3 = false;
            this.moduleShow4 = false;
            this.moduleShow5 = false;
            this.moduleShow6 = true;
        },
        onSave() {
            console.log('33333');
            console.log(this.form);
            console.log(this.id);
            post("/admin/consultComment/info/insertConsultComment",{
                ...this.form,
                consultId: this.ytid
            }).then(res => {
                console.log(res)
                this.$emit("close")
            })
        },
        getData() {
            this.form = {};
        },
        quxiao() {
            
        },
        closeViewJiaoban() {
          this.$emit("close")
          this.getPageDatas();
        },
        closeViewBanLi() {
          this.$emit('close')
          this.getPageDatas();
        },
        closeViewJieGuo() {
          this.showJieGuo = false;
          this.getPageDatas();
        },
        closeViewGongShi() {
          this.showGongShi = false;
          // this.getPageDatas();
        },
        closeViewGongShi1() {
          this.showGongShi1 = false;
          this.getPageDatas();
        },
        closeViewGongShiJiLi() {
          this.showGongShiJiLu = false;
          this.getPageDatas();
        },
        closeViewGongShiJiLi1() {
          this.showGongShiJiLu1 = false;
          this.getPageDatas();
        },
        closeViewPingYiHuiZong() {
          this.showPingYiHuiZong = false;
          this.getPageDatas();
        },
        closeViewGongShiShenHe() {
          this.showGongShiShenHe = false;
          this.getPageDatas();
        },
        closeViewPingYiShenHe() {
          this.showPingYiShenHe = false;
          this.getPageDatas();
        },
        handleRemove(file, fileList) {
        console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(file, fileList) {
            console.log(file, fileList);
            console.log(file.content);
            this.form.photo = file.content;
        }
    }, 
}
</script>

<style lang="less" scoped>
.consulAddDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.centerBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  .qubtn{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  } 
  .qubtn :hover{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span{
      color:#409EFF; 
      margin-top:10px
  }

}
</style>